import { useMemo } from 'react';
import { useLocation } from 'react-router';

interface LoginQueryParams {
  idp?: string;
  schema?: string;
  token?: string;
}

export const useLoginQueryParams = (): LoginQueryParams => {
  const { search } = useLocation();
  const params = useMemo(() => new URLSearchParams(search), [search]);

  const { idp, schema, token } = useMemo(() => {
    return {
      idp: params.get('idp') || undefined,
      schema: params.get('schema') || undefined,
      token: params.get('token') || undefined,
    };
  }, [params]);

  return {
    idp,
    schema,
    token,
  };
};
